import Geohash from 'latlon-geohash';
import GeoJsonValidator from 'geojson-validation';

export const daysAsInt = {
  MONDAY: 0,
  TUESDAY: 1,
  WEDNESDAY: 2,
  THURSDAY: 3,
  FRIDAY: 4,
  SATURDAY: 5,
  SUNDAY: 6
};

export const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];
export const daysUpper = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY'
];
export const daysInOrder = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
];
export const months = [
  'Jan',
  'Feb',
  'March',
  'April',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'December'
];

/* eslint(import/prefer-default-export) = 0 */

export const geoHashFromGeoJson = (
  data // eslint-disable-line import/prefer-default-export
) =>
  data.features.map(item => {
    const [lon, lat] = item.geometry.coordinates;
    return Geohash.encode(lat, lon, 8);
  });

export const parseDate = (unixTimestamp: number): string => {
  const date = new Date(unixTimestamp);
  return date.toString();
};

export const parseJson = (data: string): any => {
  if (typeof data === 'string') {
    let parsed;
    try {
      parsed = JSON.parse(data);
    } catch (e) {
      // console.error(`Invalid json supplied: ${e}`);
      return false;
    }
    // If it's still a string, we parse again
    if (typeof parsed === 'string') {
      return parseJson(parsed);
    }
    return parsed;
  }
  return data;
};

export const parseGeoJson = data => {
  if (GeoJsonValidator.valid(data)) {
    return data;
  }
  if (typeof data === 'string') {
    let parsed;
    try {
      parsed = JSON.parse(data);
    } catch (e) {
      // console.error(`Invalid json supplied: ${e}`);
      return false;
    }
    // If it's still a string, we parse again
    if (typeof parsed === 'string') {
      return parseGeoJson(parsed);
    }
    return parsed;
  }
  return false;
};

export const round = (measurement: number): number => {
  return Math.round((measurement + Number.EPSILON) * 100) / 100;
};

export const reserveCoords = (coords: number[][]): number[][] =>
  coords.map(coord => [coord[1], coord[0]]);

export const arrayToKeys = (key: string, arr: any) => {
  const objectWithKeys = {};
  const keys = [];
  arr.forEach(item => {
    keys.push(item[key]);
    objectWithKeys[item[key]] = item;
  });
  return { objectWithKeys, keys };
};

export const routeToCoordsString = route => {
  return route?.features
    .map(feature => feature.geometry.coordinates)
    .reduce((acc, point) => acc + `${point[1]},${point[0]}|`, '')
    .slice(0, -1);
};

export const getDistanceBetweenPoints = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number => {
  const dLat = deg2rad(lat1 - lat2); // deg2rad below
  const dLon = deg2rad(lon1 - lon2);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const d = 6371e3 * c; // Distance in m
  return parseInt(d.toFixed(2));
};

const deg2rad = (deg: number): number => {
  return deg * (Math.PI / 180);
};

export const missionPointsCollectionToPolyline = missionRoute => {
  if (missionRoute) {
    return missionRoute.features.map(point => {
      return [point.geometry.coordinates[1], point.geometry.coordinates[0]];
    });
  } else {
    return [];
  }
};

export const dateIsTomorrow = (date: Date) => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  return (
    date.getFullYear() === tomorrow.getFullYear() &&
    date.getMonth() === tomorrow.getMonth() &&
    date.getDate() === tomorrow.getDate()
  );
};
export const dateIsToday = (date: Date) => {
  const today = new Date();
  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  );
};

export const hexToLong = (hex: string): string => {
  return BigInt('0x' + hex).toString();
};
